import { PersonType } from 'es/app/business-logic/domain-models/People';
import urlJoin from 'url-join';
import Guid from 'es/core/types/Guid';

const SYSTEM_ROOT = '/system';

const r = (route: string) => urlJoin(SYSTEM_ROOT, route);

export const SystemRouteMap = {
    root: () => SYSTEM_ROOT,
    accessGroups: {
        search: () => r('/access-groups'),
        create: () => r('/access-groups/new'),
        edit: (id?: Guid) => r(`/access-groups/edit/${id ?? ':id'}`),
    },

    people: {
        search: () => r(`/people`),
        create: (type?: PersonType) => r(`/people/${type?.toString()?.toLowerCase() ?? ':type'}/new`),
        edit: (type?: PersonType | null, id?: Guid) => {
            const rootPath = r(`/people/${type?.toLowerCase() ?? ':type'}/${id ?? ':id'}`);
            return {
                root: rootPath,
                access: `${rootPath}/access`,
                overrides: `${rootPath}/overrides`,
            };
        },
    },

    facilities: {
        search: () => r('/facilities'),
        create: () => r('/facilities/new'),
        edit: (id?: Guid) => {
            const rootPath = r(`/facilities/edit/${id ?? ':id'}`);
            return {
                root: rootPath,
                features: `${rootPath}/features`,
                users: `${rootPath}/users`,
            };
        },
    },

    library: {
        search: () => r('/library'),
        pollutants: {
            search: () => r('/library/pollutants'),
            view: (id?: Guid) => {
                const rootPath = r(`/library/pollutants/${id ?? ':id'}`);
                return {
                    root: rootPath,
                };
            },
        },
        units: {
            search: () => r('/library/units'),
            view: (id?: Guid) => {
                const rootPath = r(`/library/units/${id ?? ':id'}`);
                return {
                    root: rootPath,
                };
            },
        },
        noiseClassifications: {
            search: () => r('/library/noise-classifications'),
            create: () => r('/library/noise-classifications/new'),
            view: (id?: Guid) => {
                const rootPath = r(`/library/noise-classifications/${id ?? ':id'}`);
                return {
                    root: rootPath,
                };
            },
        },
    },

    ssoUserTemplates: ssoUserTemplateRouteMap(),
};

function ssoUserTemplateRouteMap() {
    const root = '/sso-user-templates';
    return {
        search: () => r(root),
        create: () => {
            const rootPath = r(`${root}/new`);
            return {
                root: rootPath,
                accessGroups: `${rootPath}/access-groups`,
            };
        },
        edit: (id?: Guid) => {
            const rootPath = r(`${root}/edit/${id ?? ':id'}`);
            return {
                root: rootPath,
                accessGroups: `${rootPath}/access-groups`,
            };
        },
    };
}

export const isSystemRoute = (route: Location | string) => {
    const pathname = route instanceof Location ? route.pathname : route;
    return pathname.startsWith(SystemRouteMap.root());
};

export default SystemRouteMap;
